import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class PermissionServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getItem(user_id) {
    return this.http.get(`${user_id}/permissions`);
  }
}

export const PermissionService = new PermissionServiceClass({
  api_version: 2,
  resource: 'users'
});
